<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text small color="primary" class="ml-3" v-bind="attrs" v-on="on">
          Perfil
        </v-btn>
      </template>

      <v-card class="card-rounded">
        <v-form
          @submit.prevent="updateProfile"
          ref="updateUserProfileForm"
          lazy-validation
        >
          <v-card-title>
            <span class="headline">Perfil</span>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="profile.nome"
                    label="Nome"
                    :loading="getUserProfileLoading"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="profile.telefone"
                    label="Telefone"
                    :loading="getUserProfileLoading"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                  <date-picker
                    key="dtpData"
                    :label="'Data Aniversário'"
                    v-model="profile.aniversario"
                  ></date-picker>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="profile.endereco"
                    label="Telefone"
                    :loading="getUserProfileLoading"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="updateLoading"
              color="primary"
              text
              @click.native="closeDialog"
            >
              Fechar
            </v-btn>
            <v-btn :disabled="updateLoading" color="primary" text type="submit">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import datePicker from "../../components/date-picker";

export default {
  components: {
    "date-picker": datePicker,
  },

  props: {
    closeOnClickMethod: {
      type: Function,
      required: false,
    },
    closeMenuMethod: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      profile: {},
      getUserProfileLoading: false,
      updateLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      session: "session",
    }),
  },
  watch: {
    dialog(v) {
      if (v) {
        this.profile = {};
        this.resetForm();
        this.getUserProfile();
      }
    },
  },
  mounted() {
    console.log("profile");
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    resetForm() {
      if (this.$refs.updateUserProfileForm) {
        this.$refs.updateUserProfileForm.reset();
      }
    },
    clicPerfil() {
      this.dialog = true;
    },
    validateForm() {
      if (this.$refs.updateUserProfileForm.validate()) {
        return true;
      }
      return false;
    },
    getUserProfile() {
      this.getUserProfileLoading = true;
      this.$store
        .dispatch("fetchProfile", this.session.user.uid)
        .then((result) => {
          this.profile = result;
        })
        .catch((err) => console.log("err", err))
        .finally(() => {
          this.getUserProfileLoading = false;
        });
    },
    updateProfile() {
      if (this.validateForm()) {
        this.updateLoading = true;
        var payload = { data: this.profile, uid: this.session.user.uid };
        this.$store
          .dispatch("updateProfile", payload)
          .then(() => {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: "Registro atualizado com sucesso!",
            });
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.updateLoading = false;
          });
      }
    },
  },
};
</script>
